export default {"src":"/_next/static/media/heart_like.f59fedb7.svg","height":17,"width":20};